import {createReducer, createActions} from 'reduxsauce';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
    changeSearchPageNum: ["args"],
    changeActivedType: ["args"],
    changeKeyword: ["args"],
    clearFullSearch: ["args"],
    fullSearch: ["args"],
    fullFetchResult: ["result"],
    fullFetchStatResult: ["result"]
});

const INIT_RESULT = {
  pageNum: 1,
  pageSize: 20,
  totoal: 0,
  items: [],
  statSummary: {
      exhausted: true,
      statByType: [],
  },
}

export const FullSearchTypes = Types;
export const INITIAL_STATE = {
    searching: false,
    activedType: "",
    keyword: "",
    searchKey: "",
    pageNum: 0,
    pageSize: 20,
    result: INIT_RESULT
};

export const changeActivedType = (state = INITIAL_STATE, {args}) => {
    const result = {...state.result, items: []};
    return {
        ...state, pageNum: args.pageNum, activedType: args.activedType, searching: !!args.searchKey, result,
    };
};

export const changeSearchPageNum = (state = INITIAL_STATE, {args}) => {
    return {...state, pageNum: args.pageNum, searching: true};
};

export const changeKeyword = (state = INITIAL_STATE, {args}) => {
    return {...state, keyword: args.keyword};
};

export const clearFullSearch = (state = INITIAL_STATE, {args}) => {
    return {...state, pageNum: 0, searchKey: '', keyword: '', result: INIT_RESULT, activedType: args.activedType};
};

export const fullSearch = (state = INITIAL_STATE, {args}) => {
  return {...state, pageNum: 0, searchKey: args.searchKey, keyword: args.searchKey, searching: true, activedType: args.activedType};
};

export const fullFetchResult = (state = INITIAL_STATE, {result}) => {
    return {...state, result, searching: false};
};

export const fullFetchStatResult = (state = INITIAL_STATE, {result}) => {
    const newResult = { ...state.result, statSummary: result.statSummary }
    return {...state, result: newResult, searching: false};
};


export const reducer = createReducer(INITIAL_STATE, {
    [Types.CHANGE_SEARCH_PAGE_NUM]: changeSearchPageNum,
    [Types.CHANGE_ACTIVED_TYPE]: changeActivedType,
    [Types.CHANGE_KEYWORD]: changeKeyword,
    [Types.CLEAR_FULL_SEARCH]: clearFullSearch,
    [Types.FULL_SEARCH]: fullSearch,
    [Types.FULL_FETCH_RESULT]: fullFetchResult,
    [Types.FULL_FETCH_STAT_RESULT]: fullFetchStatResult,
});

export default Creators;
